import React from 'react'
import {data} from '../CRMData/CRMDashTabData';
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import "./dashTable.css"
import DotsComponent from '../../DotsComponent';
// import '../CRMComponent/'
export const CRMDashTable = () => {
  return (
    <div  className='crm-table' style={{width:'96%'}}>
        <DotsComponent/>
            <div className="graph_heading">
              <h1 className="Graph_title">Customer Support</h1>
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </div>
            <div className='tickets'>Tickets<hr/></div>

        <div className='header'> 
          <div className='in-header'>
              <span>Unassigned</span>
              <span>Assigned to me</span>
              <span>All Ticket</span>
              <span>Archived</span>
          </div>
        </div>

    <div className='table-box'>
        <table  className="th-light">
         <tr>
             <th>Full Name</th>
                <th>Order Id</th>
                <th>Item Name</th>
                <th>Status</th>
                <th>Query Details</th>
                <th>Date</th>
                <th>Type</th>
                <th>Rating</th>
                <th>Action</th>
           </tr>
           {data.map((val)=>{
             return(
                    <tr>
                      <td>{val.fname}</td>
                      <td>{val.orderId}</td>
                      <td>{val.itemName}</td>
                      <td >{val.status}</td>
                      <td>{val.queryDetails}</td>
                      <td>{val.date}</td>
                      <td>{val.type}</td>
                      <td>{val.rating}</td>
                      <td><button>{val.action}</button></td>
                      </tr>
             );
           })}

        </table>  

    </div>
    </div>

   
  )
}
